import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import getSetCookie from '../../../cookie';
import { deleteDittoCookie } from '../../../utils/helper';
import BottomSheet from '../../../mobile/components/BottomSheet/BottomSheet';
import * as commonCallsActionCreators from '../../../actionCreators/common';
import * as categoryActions from '../../../actionCreators/category';
import LKModal from '../Modal/Modal';
import Header from '../../../mobile/components/MyAccount/Header';
import './CygnusProfile.scss';

let platform = 'desktop';

const CygnusProfile = props => {
  const dispatch = useDispatch();
  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const [isDeleteDittoCalled, setIsDeleteDittoCalled] = useState(false);
  const {
    commonCallsAction,
    userInfo,
    dataLocale,
    cygnusProfile,
    cygnusProfileError,
    deleteDittoData,
    deleteDittoDataError,
    categoryActions,
    redisCommonData,
    history,
  } = props;
  const {
    DELETE,
    CANCEL,
    NO_3D_FOUND,
    START_3D,
    SYMBOL_EXCLAIMATON,
    DELETE_CONFIRMATION,
    ARE_YOU_WANT_DELETE_DITTO,
    MY_3D,
  } = dataLocale;

  useEffect(() => {
    if (redisCommonData.SHOW_DELETE_DITTO) {
      getCygnusDataCall();
      if (process.env.CLIENT_TYPE === 'mobile') platform = 'mobile';
    }
  }, []);

  useEffect(() => {
    if (cygnusProfileError) {
      if (isDeleteDittoCalled) {
        setIsDeleteDittoCalled(false);
      } else if (cygnusProfileError && cygnusProfileError?.errorCode !== 404) {
        commonCallsAction.setToastMessage({
          error: true,
          message: cygnusProfileError.message,
          timeout: 5000,
        });
        commonCallsAction.resetCygnusErrorData();
      }
    }
  }, [cygnusProfileError]);

  useEffect(() => {
    if (deleteDittoData) {
      setIsDeleteDittoCalled(true);
      getCygnusDataCall();
      deleteDittoCookie();
      dispatch(commonCallsActionCreators.validateSessionV2());
      categoryActions.updateDittoEnable(false);
      commonCallsAction.updateTryOnSwitch({ isTryOnSwitch: false });
    }
  }, [deleteDittoData]);

  useEffect(() => {
    if (deleteDittoDataError) {
      commonCallsAction.setToastMessage({
        error: true,
        message: deleteDittoDataError.message,
        timeout: 5000,
      });
      commonCallsAction.resetCygnusErrorData();
    }
  }, [deleteDittoDataError]);

  const getCygnusDataCall = () => {
    if (userInfo?.telephone && userInfo?.phoneCode)
      commonCallsAction.getCygnusProfile({
        phNumber: userInfo?.telephone,
        phoneCode: userInfo?.phoneCode,
        clientName: platform,
      });
    else if (getSetCookie.getCookie('dittoGuestId'))
      commonCallsAction.getCygnusProfile({
        dittoGuestId: getSetCookie.getCookie('dittoGuestId'),
        clientName: platform,
      });
    else {
      commonCallsAction.resetCygnusData();
    }
  };

  function deleteHandler(e) {
    commonCallsAction.deleteCygnus({
      phNumber: userInfo?.telephone,
      phoneCode: userInfo?.phoneCode,
      clientName: platform,
    });
    setShowBottomSheet(false);
  }

  function toggleSheet() {
    setShowBottomSheet(showBottomSheet => !showBottomSheet);
  }

  if (!redisCommonData.SHOW_DELETE_DITTO) {
    return '';
  } else {
    return (
      <>
        {platform === 'mobile' && <Header history={history} navLink={true} title={MY_3D} />}
        <div className="cygnusProfiles">
          <div
            className="cygnus-container"
            style={{ alignItems: cygnusProfile?.image_url ? "initial" : "center" }}
          >
            {cygnusProfile?.image_url && (
              <div key={'cygnus' + cygnusProfile.id} className="card-container">
                <img alt="cygnus" className="cygnus-img" src={cygnusProfile.image_url} />
                <span className="delete-text-button" onClick={toggleSheet}>
                  {DELETE}
                </span>
                {/* <div className="button-container">
                <button onClick={toggleSheet}>{DELETE}</button>
              </div> */}
              </div>
            )}
            {!cygnusProfile && (
              <>
                <div style={{ fontSize: '18px' }}>
                  {NO_3D_FOUND || 'No 3D Found'}
                  {SYMBOL_EXCLAIMATON}
                </div>
                <div
                  className="btn-3d fs14 text-center block bora-4 fw700 text-uppercase"
                  onClick={() => history.push('/compare-looks')}
                >
                  {START_3D}
                </div>
              </>
            )}
          </div>
          {showBottomSheet && platform === 'mobile' && (
            <BottomSheet
              addTopRadius
              backdrop
              expanded={showBottomSheet}
              onClickBackdrop={() => setShowBottomSheet(false)}
            >
              <div className="bottom-content-container">
                <div className="bottom-title">{DELETE_CONFIRMATION}</div>
                <div className="bottom-message">{ARE_YOU_WANT_DELETE_DITTO}</div>
                <div className="button-container">
                  <button className="outline" onClick={toggleSheet}>
                    {CANCEL.toUpperCase()}
                  </button>
                  <button className="solid" onClick={deleteHandler}>
                    {DELETE.toUpperCase()}
                  </button>
                </div>
              </div>
            </BottomSheet>
          )}

          {showBottomSheet && platform === 'desktop' && (
            <LKModal
              backdrop
              keyboard
              showModal={showBottomSheet}
              size="medium"
              dialogClassName="medium-modal"
              hideHandler={() => setShowBottomSheet(false)}
            >
              <div className="bottom-content-container">
                <div className="bottom-title">{DELETE_CONFIRMATION}</div>
                <div className="bottom-message">{ARE_YOU_WANT_DELETE_DITTO}</div>
                <div className="button-container">
                  <button className="outline" onClick={toggleSheet}>
                    {CANCEL.toUpperCase()}
                  </button>
                  <button className="solid" onClick={deleteHandler}>
                    {DELETE.toUpperCase()}
                  </button>
                </div>
              </div>
            </LKModal>
          )}
        </div>
      </>
    );
  }
};

const mapStateToProps = state => ({
  cygnusProfile: state.common.cygnusProfile,
  cygnusProfileError: state.common.cygnusProfileError,
  deleteDittoData: state.common.deleteDittoData,
  deleteDittoDataError: state.common.deleteDittoDataError,
  redisCommonData: state.common.redisCommonData,
  dataLocale: state.locale,
  userInfo: (state.common.userInfo && state.common?.userInfo?.result) || null,
});

function mapDispatchToProps(dispatch) {
  return {
    commonCallsAction: bindActionCreators(commonCallsActionCreators, dispatch),
    categoryActions: bindActionCreators(categoryActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CygnusProfile);
